import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSwLogoWhite = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 169 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M22.693 24.048q1.596 0 3.003.567a7.5 7.5 0 0 1 2.446 1.575 7.5 7.5 0 0 1 1.649 2.404q.609 1.397.609 3.056t-.609 3.056a7.5 7.5 0 0 1-1.649 2.404 7.5 7.5 0 0 1-2.446 1.575 8 8 0 0 1-3.003.567 8 8 0 0 1-3.024-.567 7.5 7.5 0 0 1-2.447-1.575 7.5 7.5 0 0 1-1.648-2.404q-.609-1.397-.609-3.056t.609-3.055a7.5 7.5 0 0 1 1.649-2.405 7.5 7.5 0 0 1 2.446-1.575 8 8 0 0 1 3.024-.567m91.134.252 4.746 14.7h-3.885l-1.029-3.423h-3.969L108.724 39h-3.801l4.62-14.7zm-18.262 0 .397.007q1.567.052 2.837.529 1.428.535 2.415 1.501a6.5 6.5 0 0 1 1.512 2.32q.525 1.356.525 2.993 0 1.639-.525 2.992a6.5 6.5 0 0 1-1.512 2.321q-.987.966-2.415 1.502-1.428.534-3.234.535H90V24.3zm-14.146 0 .343.007q1.016.045 1.862.35a5.1 5.1 0 0 1 1.69.987q.704.63 1.082 1.48.378.852.378 1.817 0 .588-.126 1.176t-.441 1.134-.83 1.029a4.8 4.8 0 0 1-1.291.84L87.488 39h-4.074l-2.772-5.145h-1.743V39h-3.612V24.3zm-9.253 0v3.129h-7.875v2.52h4.221v3.108h-4.221v2.814h7.875V39H60.679V24.3zm-14.104 0v3.255h-4.284V39h-3.591V27.555h-4.305V24.3zm-13.684 0v3.255h-4.284V39h-3.591V27.555h-4.305V24.3zm-37.175 0 .343.007q1.016.045 1.862.35a5.1 5.1 0 0 1 1.69.987q.704.63 1.082 1.48.378.852.378 1.817 0 .588-.126 1.176t-.441 1.134-.83 1.029a4.8 4.8 0 0 1-1.291.84L13.272 39H9.198l-2.772-5.145H4.683V39H1.071V24.3zm118.775 0 2.604 6.867 2.793-6.867h4.599V39h-3.612v-8.904l-2.205 5.754h-3.339l-2.289-5.754V39h-3.57V24.3zM95.67 27.429h-2.058v8.442h2.058q.735 0 1.428-.252a3.5 3.5 0 0 0 1.239-.777q.546-.525.882-1.323t.336-1.869-.336-1.869a3.8 3.8 0 0 0-.882-1.312 3.7 3.7 0 0 0-1.239-.777 4 4 0 0 0-1.428-.263m-72.977.021q-.881 0-1.607.315-.724.315-1.228.882a4.2 4.2 0 0 0-.788 1.334 4.8 4.8 0 0 0-.283 1.669q0 .903.284 1.67.282.765.787 1.333.503.567 1.229.882.724.315 1.606.315t1.596-.315 1.228-.882.788-1.334a5 5 0 0 0 .273-1.669q0-.902-.273-1.67a3.9 3.9 0 0 0-.788-1.333 3.6 3.6 0 0 0-1.228-.882 3.9 3.9 0 0 0-1.596-.315m88.992.924h-.084l-1.134 4.074h2.352zm-30.749-.945h-2.037v3.234h2.037q1.113 0 1.596-.451.483-.453.483-1.187 0-.756-.483-1.176t-1.596-.42m-74.216 0H4.683v3.234H6.72q1.113 0 1.596-.451.483-.453.483-1.187 0-.756-.483-1.176t-1.596-.42M88.428 5.048q1.596 0 3.003.567a7.5 7.5 0 0 1 2.447 1.575 7.5 7.5 0 0 1 1.648 2.404q.609 1.397.609 3.056t-.609 3.056a7.5 7.5 0 0 1-1.648 2.404 7.5 7.5 0 0 1-2.447 1.575 8 8 0 0 1-3.003.567 8 8 0 0 1-3.024-.567 7.5 7.5 0 0 1-2.447-1.575 7.5 7.5 0 0 1-1.648-2.404q-.609-1.397-.609-3.056t.609-3.056a7.5 7.5 0 0 1 1.648-2.404 7.5 7.5 0 0 1 2.447-1.575 8 8 0 0 1 3.024-.567m-32.85 0q1.449 0 2.866.504a6.3 6.3 0 0 1 2.489 1.638l-1.995 2.541-.186-.192a4.05 4.05 0 0 0-1.42-.931q-.872-.327-1.544-.326-.735 0-1.06.336-.327.336-.326.672 0 .273.189.578.189.303.861.598l1.722.756.334.154q.816.387 1.42.78.725.474 1.175 1.019.452.546.651 1.165.2.62.2 1.376 0 .84-.346 1.659a4.3 4.3 0 0 1-1.019 1.46q-.672.64-1.68 1.028-1.008.39-2.331.389a8 8 0 0 1-1.9-.22 9 9 0 0 1-1.607-.547 7.6 7.6 0 0 1-1.26-.713 6 6 0 0 1-.861-.725l1.953-2.604.155.155q.244.231.559.443.42.284.893.505.472.22.997.346a4.4 4.4 0 0 0 1.029.126q.756 0 1.134-.346.378-.348.378-.809t-.367-.798q-.368-.336-1.166-.693l-1.68-.735-.262-.118q-3.077-1.443-3.077-4.124 0-.945.399-1.732a4.5 4.5 0 0 1 1.081-1.376q.684-.588 1.607-.913a6 6 0 0 1 1.995-.326m-49.95 0q1.45 0 2.867.504a6.3 6.3 0 0 1 2.488 1.638l-.018-.017v.039L8.988 9.731l-.186-.192a4.05 4.05 0 0 0-1.42-.931q-.872-.327-1.544-.326-.735 0-1.06.336t-.326.672q0 .273.189.578.189.303.861.598l1.722.756.335.154a12 12 0 0 1 1.418.78q.724.474 1.176 1.019.451.546.652 1.165.2.62.199 1.376 0 .84-.346 1.659a4.3 4.3 0 0 1-1.019 1.46q-.672.64-1.68 1.028-1.008.39-2.331.389a8 8 0 0 1-1.9-.22 9 9 0 0 1-1.607-.547 7.6 7.6 0 0 1-1.26-.713A6 6 0 0 1 0 18.047l1.953-2.604.155.155q.244.231.559.443.42.284.893.505.472.22.997.346a4.4 4.4 0 0 0 1.029.126q.756 0 1.134-.346.378-.348.378-.809t-.367-.798q-.368-.336-1.166-.693l-1.68-.735-.262-.118Q.546 12.076.546 9.395q0-.945.399-1.732a4.5 4.5 0 0 1 1.082-1.376q.681-.588 1.606-.913a6 6 0 0 1 1.995-.326m96.012.252 4.305 8.715V5.3h3.57V20h-4.2l-4.599-8.841V20h-3.57V5.3zm26.907 0 4.305 8.715V5.3h3.57V20h-4.2l-4.599-8.841V20h-3.57V5.3zm-63.768 0 1.869 9.093h.021L69.105 5.3h3.633l2.394 9.093h.021L77.106 5.3h3.717L77.253 20h-3.864L70.848 9.983 68.37 20h-3.906l-3.57-14.7zm-22.497 0 .397.007q1.567.053 2.837.528 1.428.536 2.415 1.502a6.5 6.5 0 0 1 1.512 2.32q.525 1.355.525 2.993t-.525 2.992a6.5 6.5 0 0 1-1.512 2.321q-.987.966-2.415 1.502-1.428.535-3.234.535h-5.565V5.3zm-10.797 0L36.231 20h-3.885l-1.029-3.423h-3.969L26.382 20h-3.801l4.62-14.7zm-8.34 0v3.255h-4.284V20H15.27V8.555h-4.305V7.212l.018-.022-.018-.017V5.3zm99.687 0v3.129h-7.875v2.52h4.221v3.108h-4.221v2.814h7.875V20h-11.487V5.3zM42.387 8.429h-2.058v8.442h2.058q.735 0 1.428-.252a3.5 3.5 0 0 0 1.239-.777q.546-.525.882-1.323t.336-1.869-.336-1.869a3.8 3.8 0 0 0-.882-1.312 3.7 3.7 0 0 0-1.239-.777 4 4 0 0 0-1.428-.263m46.041.021q-.882 0-1.606.315t-1.229.882a4.2 4.2 0 0 0-.788 1.333 4.8 4.8 0 0 0-.283 1.67q0 .903.283 1.67.284.766.788 1.333t1.228.882 1.607.315 1.596-.315 1.228-.882q.515-.566.788-1.334a5 5 0 0 0 .273-1.669q0-.903-.273-1.67a3.9 3.9 0 0 0-.788-1.333 3.6 3.6 0 0 0-1.228-.882 3.9 3.9 0 0 0-1.596-.315m-59.085.924h-.084l-1.134 4.074h2.352z"
      clipRule="evenodd"
    />
    <path
      fill="#BCE4FA"
      fillRule="evenodd"
      d="m143 25.997 6.499 6.5L143 38.994z"
      clipRule="evenodd"
    />
    <path
      fill="#FE0"
      fillRule="evenodd"
      d="m143 12.998 6.499 6.5L143 25.997z"
      clipRule="evenodd"
    />
    <path
      fill="#FADCEB"
      fillRule="evenodd"
      d="m155.998 25.997-6.499-6.5L155.998 13z"
      clipRule="evenodd"
    />
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="m155.998 12.998-6.499 6.5-6.499-6.5z"
      clipRule="evenodd"
    />
    <path
      fill="#7D6EA5"
      fillRule="evenodd"
      d="m143 25.997 6.499-6.5 6.499 6.5z"
      clipRule="evenodd"
    />
    <path
      fill="#E63312"
      fillRule="evenodd"
      d="m155.998 25.997 6.5 6.5-6.5 6.498z"
      clipRule="evenodd"
    />
    <path
      fill="#ED694B"
      fillRule="evenodd"
      d="m155.998 12.998 6.5 6.5-6.5 6.499z"
      clipRule="evenodd"
    />
    <path
      fill="#BCE4FA"
      fillRule="evenodd"
      d="m168.997 25.997-6.5-6.5 6.5-6.499z"
      clipRule="evenodd"
    />
    <path
      fill="#FFF59B"
      fillRule="evenodd"
      d="m168.997 12.998-6.5 6.5-6.499-6.5z"
      clipRule="evenodd"
    />
    <path
      fill="#FFF59B"
      fillRule="evenodd"
      d="m155.998 25.997 6.499-6.5 6.5 6.5z"
      clipRule="evenodd"
    />
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="m155.998 0 6.5 6.5-6.5 6.498z"
      clipRule="evenodd"
    />
    <path
      fill="#E63312"
      fillRule="evenodd"
      d="m155.998 12.999-6.499-6.5L155.998 0z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A941"
      fillRule="evenodd"
      d="m155.998 38.995-6.499-6.5 6.499-6.498z"
      clipRule="evenodd"
    />
    <path
      fill="#FED27A"
      fillRule="evenodd"
      d="m168.997 38.995-6.499-6.499 6.499-6.5zM155.998 25.997l-6.499 6.499-6.499-6.5z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A941"
      fillRule="evenodd"
      d="m168.997 25.997-6.499 6.5-6.5-6.5z"
      clipRule="evenodd"
    />
    <path
      fill="#55468B"
      fillRule="evenodd"
      d="m155.998 12.999 6.5-6.5 6.499 6.5z"
      clipRule="evenodd"
    />
    <path
      fill="#F29FC5"
      fillRule="evenodd"
      d="m143 38.995 6.499-6.5 6.499 6.5z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A941"
      fillRule="evenodd"
      d="m143 12.998 6.499-6.499 6.499 6.5z"
      clipRule="evenodd"
    />
    <path
      fill="#F18700"
      fillRule="evenodd"
      d="m155.998 38.995 6.5-6.5 6.499 6.5z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSwLogoWhite);

export default ForwardRef;
